export const upperCaseFirst = (name) =>
  name.charAt(0).toUpperCase() + name.slice(1);
